import React from "react";
import {GenericTable} from '../Tables/GenericTable';

import {StreamBankTableCellRenderer} from "../Table/StreamBankTableCellRenderer";

// export class StreamBankTable extends React.Component {
export const StreamBankTable = React.forwardRef((props, ref) => {
	const {className = ''} = props;
	
	return <GenericTable
		
		ref={ref}
		defaultCellRenderer={StreamBankTableCellRenderer}
		// className={"sb-table top10 " + props?.className}
		headerClassName="sb-table-header"
		sortColumn="name"
		sortAsc={true}
		{...{
			...props,
			className: className +  " sb-table top10"
		}}
		
	/>;
});
